import React from "react"
import { useGeoData } from "../context/GeoDataContext"
import { replaceValue } from "@/util/string"

interface GeoContentProps {
  template: string
  fallbackText?: string
  className?: string
  skeletonClassName?: string
}

export const GeoContent: React.FC<GeoContentProps> = ({
  template,
  fallbackText = "Local",
  className = "",
  skeletonClassName = "animate-pulse bg-gray-200 rounded",
}) => {
  const {
    isLoading,
    hasInitialized,
    isUSVisitor,
    geoCostPerMile,
    geoCity,
  } = useGeoData()

  const updatedDescription = replaceValue(template, {
    location: geoCity,
    cost_per_mile: geoCostPerMile,
  })

  if (isLoading && !hasInitialized) {
    return (
      <span className={`min-h-6 min-w-32 ${skeletonClassName} ${className}`}>
        <span className="invisible">{fallbackText}</span>
      </span>
    )
  }

  if (
    hasInitialized &&
    isUSVisitor &&
    geoCity &&
    updatedDescription !== template
  ) {
    return (
      <span
        className={`min-h-6 min-w-32 transition-opacity duration-200 ${className}`}
      >
        {updatedDescription}
      </span>
    )
  }

  return (
    <span
      className={`min-h-6 min-w-32 transition-opacity duration-200 ${className}`}
    >
      {fallbackText}
    </span>
  )
}

export default GeoContent
